/*-----------------------------------------------------------------------------------*/
/* 		Mian Js Start
/*-----------------------------------------------------------------------------------*/
$(document).ready(function($) {
"use strict"
/*-----------------------------------------------------------------------------------*/
/* 		CLIENTS LOGO SLIDE
/*-----------------------------------------------------------------------------------*/
$(".client-slide").owlCarousel({
	autoplay:false,
	autoplayHoverPause:true,
	singleItem	: true,
	navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	lazyLoad:true,
	nav: false,
	loop:true,
	margin:30,
	animateOut: 'fadeOut',
	responsive:{
        0:{
            items:1
        }, 
        600:{
            items:2
        },
        800:{
            items:3
        },
        1200:{
            items:5
        }}
});
/*-----------------------------------------------------------------------------------*/
/* Pretty Photo
/*-----------------------------------------------------------------------------------*/
jQuery("a[data-rel^='prettyPhoto']").prettyPhoto({
    theme: "light_square"
});
/*-----------------------------------------------------------------------------------*/
/* 		Parallax
/*-----------------------------------------------------------------------------------*/
jQuery.stellar({
   horizontalScrolling: false,
   scrollProperty: 'scroll',
   positionProperty: 'position'
});
});

//Konvert jezika "Hrvatski (Hrvatska) => Hrvatski"
jQuery(document).ready(function () {
    var counter = $("#dnn_dnnLANGUAGE_selectCulture option").length; // dohvati ukupan broj jezika
    for (var i = 0; i < counter ; i++) {
        console.log('language');
        var langugeName = $("#dnn_dnnLANGUAGE_selectCulture option")[i].text; // dohvati vrijednost pojedinog jezika
        var n = langugeName.indexOf(" "); // dohvati razmak iza kojeg se nalazi ispis regije koju ne �elimo
        langugeName = langugeName.substring(0, n); // odre�i desno od razmaka i spremi
        $("#dnn_dnnLANGUAGE_selectCulture option")[i].text = langugeName; // ispi�i novu vrijednost 
    }
});